// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { useState } from 'react';
import { Box, Button, SpaceBetween } from '@cloudscape-design/components';
import { CodeView } from '@cloudscape-design/code-view';

const CopyableCodeView = ({ content }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(content)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => {
        // Fallback: clipboard API may not be available in all contexts
      });
  };

  return (
    <SpaceBetween size="xxs">
      <CodeView content={content} />
      <Box float="right">
        <Button
          iconName={copied ? 'status-positive' : 'copy'}
          variant="inline-link"
          onClick={handleCopy}
        >
          {copied ? 'Copied' : 'Copy to clipboard'}
        </Button>
      </Box>
    </SpaceBetween>
  );
};

export default CopyableCodeView;
